import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './FormLoginMfa';
import {fetchValidateOtp, resendOtp} from '@app/src/views/LoginMfa/loginMfa/state/loginMfa/actions'
import * as selectUser from '@app/src/views/LoginMfa/loginMfa/state/loginMfa/selectors';

const FormContainer = reduxForm({
  form: 'loginMfaForm',
  onSubmit (fields, dispatch, { history, urlVerification}) {
    dispatch(fetchValidateOtp(fields, history, urlVerification,));
  }
})(Form);

const mapDispatchToProps = (dispatch) => ({
  resendOtp: (url) => dispatch(resendOtp(url))
});

const mapStateToProps = state => ({
  errorMessage: selectUser.getErrorMessage(state),
  isFetching: selectUser.getIsFetching(state),
  isResending: selectUser.getIsResending(state)
});


const FormLoginMfaContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormContainer)

export default FormLoginMfaContainer;
